export const TRAVELRULE_NAVIGATION_HEADERS = [
  { label: 'Amount' },
  { label: 'Sender' },
  { label: 'Recipient' },
  { label: 'VASP' },
  { label: 'Confirm' },
]
